// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__3omDG","dragIcon":"SortableItem_dragIcon__2ti2O","disabled":"SortableItem_disabled__3zeY0"};